import * as React from "react";

import { AppContext } from "@1js/acui-context";
import {
  checkExperiment,
  ribbonExperiments,
  isNextSupportedBrowser,
} from "@1js/acui-experiments";

/** Checks if the new button experiment is enabled and if we are not in IE (no CSS variable support) */
export const useNextRibbonButtonEnabled = () =>
  checkExperiment(
    React.useContext(AppContext),
    ribbonExperiments.ribbonUseV8Button
  ) && isNextSupportedBrowser();

/** Checks if the new menu button (flyout anchor) experiment is enabled and if we are not in IE (no CSS variable support) */
export const useNextRibbonMenuButtonEnabled = () =>
  checkExperiment(
    React.useContext(AppContext),
    ribbonExperiments.ribbonUseV8MenuButton
  ) && isNextSupportedBrowser();
